import { useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import orderBy from "lodash/orderBy"
import BlogLinks from "components/landing/Articles/BlogLinks"
import PostCard from "components/PostCard"
import PostCarousel from "components/PostCarousel"
import { useCallback, useMemo } from "react"
import Typography from "../../styled/Typography"
import { Container } from "../../styled/Grid"

function Articles({ posts, page, title, minPosts, translateTitle }) {
  const t = useT()

  const orderedPosts = useMemo(() => {
    const priorityKey = `priority_${page}`
    return orderBy(posts, post => {
      const priority = Number(post[priorityKey])
      return Number.isFinite(priority) ? priority : Number.MAX_SAFE_INTEGER
    }).slice(0, 9)
  }, [posts, page])
  const renderPost = useCallback(post => <PostCard key={post.id} post={post} page={page} />, [page])

  if (posts.length < minPosts) return null

  return (
    <Container top={25} bottom={50}>
      {title && (
        <Typography variant="title2" weight="medium" center>
          {translateTitle ? t(title) : title}
        </Typography>
      )}
      <PostCarousel posts={orderedPosts} page={page} renderPost={renderPost} />
      <BlogLinks />
    </Container>
  )
}

Articles.defaultProps = {
  title: "landings.renting.title",
  minPosts: 4,
  translateTitle: true
}

Articles.propTypes = {
  posts: PropTypes.array.isRequired,
  page: PropTypes.string.isRequired,
  title: PropTypes.string,
  minPosts: PropTypes.number,
  translateTitle: PropTypes.bool
}

export default Articles
